import LocalStorage from 'web-app/services/local-storage';

export interface LatestStateInLocalStoragePayload {
    date: string;
    groupBy: string;
    groupId: string;
    displayMode: string;
    day: string;
    tagId: string;
    ageGroupId: string;
    showAllergies: string;
    showDietaryRemarks: string;
}

export const roomPlanningParametersKey = 'room-planning-parameters';

export function saveLatestStateInLocalStorage(payload: LatestStateInLocalStoragePayload): void {
    LocalStorage.saveToLocalStorage(roomPlanningParametersKey, JSON.stringify(payload));
}
